import script from "./MainSidebar.vue?vue&type=script&setup=true&lang=js"
export * from "./MainSidebar.vue?vue&type=script&setup=true&lang=js"

import "./MainSidebar.vue?vue&type=style&index=0&id=49675bb4&lang=scss"

const __exports__ = script;

export default __exports__